// Accreditations section — 8 languages
export const accreditationsI18n = {
  ru: {
    title: 'АККРЕДИТАЦИИ И ПАРТНЁРСТВА',
    items: {
      icef: 'ICEF Trusted Agency',
      bbsn: 'British Boarding Schools Network',
      englishUk: 'English UK Partner Agency',
      britishCouncil: 'British Council Training Award',
      navitas: 'Heart of Navitas Champions',
      studyTravel: 'StudyTravel Reference Checked'
    }
  },
  uk: {
    title: 'АКРЕДИТАЦІЇ ТА ПАРТНЕРСТВА',
    items: {
      icef: 'ICEF Trusted Agency',
      bbsn: 'British Boarding Schools Network',
      englishUk: 'English UK Partner Agency',
      britishCouncil: 'British Council Training Award',
      navitas: 'Heart of Navitas Champions',
      studyTravel: 'StudyTravel Reference Checked'
    }
  },
  en: {
    title: 'ACCREDITATIONS & PARTNERSHIPS',
    items: {
      icef: 'ICEF Trusted Agency',
      bbsn: 'British Boarding Schools Network',
      englishUk: 'English UK Partner Agency',
      britishCouncil: 'British Council Training Award',
      navitas: 'Heart of Navitas Champions',
      studyTravel: 'StudyTravel Reference Checked'
    }
  },
  ar: {
    title: 'الاعتمادات والشراكات',
    items: {
      icef: 'وكالة ICEF موثوقة',
      bbsn: 'شبكة المدارس الداخلية البريطانية',
      englishUk: 'وكالة شريكة English UK',
      britishCouncil: 'جائزة British Council للتدريب',
      navitas: 'أبطال Navitas',
      studyTravel: 'StudyTravel — موثّق المراجع'
    }
  },
  it: {
    title: 'ACCREDITAMENTI E PARTNERSHIP',
    items: {
      icef: 'ICEF Trusted Agency',
      bbsn: 'British Boarding Schools Network',
      englishUk: 'English UK Partner Agency',
      britishCouncil: 'British Council Training Award',
      navitas: 'Heart of Navitas Champions',
      studyTravel: 'StudyTravel Reference Checked'
    }
  },
  zh: {
    title: '认证与合作',
    items: {
      icef: 'ICEF 信任机构',
      bbsn: '英国寄宿学校网络',
      englishUk: 'English UK 合作机构',
      britishCouncil: '英国文化协会培训奖',
      navitas: 'Navitas 心动奖',
      studyTravel: 'StudyTravel 推荐认证'
    }
  },
  es: {
    title: 'ACREDITACIONES Y ALIANZAS',
    items: {
      icef: 'Agencia de Confianza ICEF',
      bbsn: 'Red de Internados Británicos',
      englishUk: 'Agencia Asociada English UK',
      britishCouncil: 'Premio de Formación British Council',
      navitas: 'Heart of Navitas Champions',
      studyTravel: 'StudyTravel Reference Checked'
    }
  },
  pl: {
    title: 'AKREDYTACJE I PARTNERSTWA',
    items: {
      icef: 'ICEF Trusted Agency',
      bbsn: 'British Boarding Schools Network',
      englishUk: 'English UK Partner Agency',
      britishCouncil: 'British Council Training Award',
      navitas: 'Heart of Navitas Champions',
      studyTravel: 'StudyTravel Reference Checked'
    }
  }
};
